import { createSelector } from 'reselect';
import { initialState } from './reducer';

const selectGlobal = (state) => state.days || initialState;

const makeSelectDaysFilterMenuStatus = () =>
  createSelector(selectGlobal, (daysState) => daysState.daysFilterMenuStatus);

export { makeSelectDaysFilterMenuStatus };
